
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as AboutViewX0rG2ZDj1SMeta } from "/Users/lysis/Documents/html/esoteric/app_dir/pages/AboutView.vue?macro=true";
import { default as curseUFRxaupYExMeta } from "/Users/lysis/Documents/html/esoteric/app_dir/pages/curse.vue?macro=true";
import { default as HomeViewstKkHMsQJsMeta } from "/Users/lysis/Documents/html/esoteric/app_dir/pages/HomeView.vue?macro=true";
import { default as indexd9ExDGg235Meta } from "/Users/lysis/Documents/html/esoteric/app_dir/pages/index.vue?macro=true";
import { default as taronPGSCvp33vMeta } from "/Users/lysis/Documents/html/esoteric/app_dir/pages/taro.vue?macro=true";
export default [
  {
    name: "AboutView",
    path: "/AboutView",
    component: () => import("/Users/lysis/Documents/html/esoteric/app_dir/pages/AboutView.vue")
  },
  {
    name: "curse",
    path: "/curse",
    component: () => import("/Users/lysis/Documents/html/esoteric/app_dir/pages/curse.vue")
  },
  {
    name: "HomeView",
    path: "/HomeView",
    component: () => import("/Users/lysis/Documents/html/esoteric/app_dir/pages/HomeView.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/lysis/Documents/html/esoteric/app_dir/pages/index.vue")
  },
  {
    name: "taro",
    path: "/taro",
    component: () => import("/Users/lysis/Documents/html/esoteric/app_dir/pages/taro.vue")
  }
]